import React from 'react';
export default class data extends React.Component {
    state ={
        data1 : "",
        
    }
    addData = data => {
        switch (data.target.name) {
            case "data1": this.setState({data1:data.target.value});break;
        
            default:
                break;
        }
    }

    render() {
        return (
            <div class={this.props.CustomerData.showResults === "2" ? '':"CustomerHidden" }>
                <div class="container" align="center">
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">ประเภทบุคคล : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="data1" value={this.state.data1} onChange={this.addData}  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> วิธีวางบิล : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>


                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> Forecast SO : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon">วัน</span> 
                        </div>
                    </div>       

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> สถานะเครดิต : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> วิธีการเก็บเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> Forecast CO : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon">วัน</span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> เหตุผลตามสถานะเครดิต : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ประเภทการจ่ายเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> Forecast PAY : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon">วัน</span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> รหัสเครดิต : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                                        
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> เงื่อนไขการวางบิล : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> Forecast PRE : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon">วัน</span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ลงวันที่สถานะ : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> เงื่อนไขการเก็บเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '><div class="input-group group-custom"></div></div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ประเภทวงเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> รหัสบัญชีลูกค้ารายตัว : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '><div class="input-group group-custom"></div></div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ตัวกลุ่มวงเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> เลขประจำตัวผู้เสียภาษี : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '><div class="input-group group-custom"></div></div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ยอกวงเงิน : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ทะเบียนการค้า : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '><div class="input-group group-custom"></div></div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ส่วนลดท้ายบิลขาย : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ภาพ 20 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '><div class="input-group group-custom"></div></div>
      
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> หมายเหตุ 1 : </span>
                            <textarea style={{resize:'none'}} rows="3"  id="id1" type="text" class="form-control input-custom" name="F_Note"  onChange=""/>
                        </div>
                    </div>
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> หมายเหตุ 2 : </span>
                            <textarea style={{resize:'none'}} rows="3"  id="id1" type="text" class="form-control input-custom" name="F_Note"  onChange=""/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}